export default "__VITE_ASSET__edb85f65__"